import axios from "axios";
import { TParsedTx } from "../types/TxCosmosApi";
import { IBlockTxs } from "../types/blockTxs";

const getBaseUrl = (env: string) => {
    return `https://${env}-full-1.omnistar.io/`
}


// http://testnetnode.omnistar.io:1317/cosmos/tx/v1beta1/txs/B2CFC637FA535C0F3B9C3D2C54E06C4D637B429DCDA5520293D0DD5BB9351CD5
// B2CFC637FA535C0F3B9C3D2C54E06C4D637B429DCDA5520293D0DD5BB9351CD5
export const  fetchCosmosTx = async ({txID, env="testnet"} : {txID: string, env?: string}) => {
    let res: any;
    try{
        const { data } =  await axios.get(
            `${getBaseUrl(env)}cosmos/tx/v1beta1/txs/${txID}`
            // `http://prod-full-1.omnistar.io:1317/cosmos/tx/v1beta1/txs/${txID}`
        );
        res = {...data};

    } catch(e){
        console.error(e);
    }
    return res;
}

// http://testnetnode.omnistar.io:1317/cosmos/feegrant/v1beta1/allowances/omnistar1j0rte6mvft3ugjyg3p2uvsrgzx9jr4dqn2len6
// omnistar1j0rte6mvft3ugjyg3p2uvsrgzx9jr4dqn2len6
export const  fetchOmniStarAccount = async ({address, env="testnet"} : {address: string, env?: string}) => {
    let res: any;
    try{
        const { data } =  await axios.get(
            `${getBaseUrl(env)}cosmos/feegrant/v1beta1/allowances/${address}`
        );
        res = {...data};

    } catch(e){
        console.error(e);
    }
    return res;
}


// "http://testnetnode.omnistar.io:1317/cosmos/bank/v1beta1/balances/omnistar1j0rte6mvft3ugjyg3p2uvsrgzx9jr4dqn2len6/by_denom?denom=nost"
export const  fetchOmniStarAccountBalances = async ({address, denom = "nost", env="testnet"} : {address: string, denom?: string, env?: string}) => {
    let res: any;
    try{
        const { data } =  await axios.get(
            `${getBaseUrl(env)}cosmos/bank/v1beta1/balances/${address}/by_denom?denom=${denom}`
        );
        
        res = {...data};

    } catch(e){
        console.error(e);
    }
    return res;
}

export const  fetchAccountRawData = async ({address, isCreator, env="testnet"} : {address: string, isCreator: boolean, env?: string}) => {
    let res: any;
    try{
        const queryParam = isCreator? "creator" : "destination";
        const { data } =  await axios.get(
            `${getBaseUrl(env)}omnistar/omnistar/raw_data?${queryParam}=${address}`
        );
        res = {...data};

    } catch(e){
        console.error(e);
    }
    return res;
}

export const  fetchTx = async ({txHash, env="testnet"} : {txHash: string, env?: string}) => {
    let res: any;
    try{
        const { data } =  await axios.get(
            // `http://testnet-full-1.omnistar.io:1317/cosmos/tx/v1beta1/txs/${txHash}`
            `${getBaseUrl(env)}cosmos/tx/v1beta1/txs/${txHash}`
        );
        if(!!data) 
            res = {body: {...data.tx.body}, auth_info: {...data.tx.auth_info}, signatures: [...data.tx.signatures], height: data.tx_response.height } as TParsedTx;

    } catch(e){
        console.error(e);
    }
    return res;
}

export const  fetchBlockTxs = async ({blockId, env="testnet"} : {blockId: string, env?: string}) => {
    let res: IBlockTxs | undefined;
    try{
        const { data } =  await axios.get(
            // `http://testnet-full-1.omnistar.io:1317/cosmos/tx/v1beta1/txs/${blockId}`
            `${getBaseUrl(env)}cosmos/tx/v1beta1/txs/block/${blockId}`
        );
        if(!!data) 
            res = data as IBlockTxs;
            // res = {body: {...data.tx.body}, auth_info: {...data.tx.auth_info}, signatures: [...data.tx.signatures], height: data.tx_response.height } as TParsedTx;

    } catch(e){
        console.error(e);
    }
    return res;
}



// http://testnet-full-1.omnistar.io:1317/omnistar/omnistar/raw_data?creator=omnistar1j0rte6mvft3ugjyg3p2uvsrgzx9jr4dqn2len6
// http://testnet-full-1.omnistar.io:1317/omnistar/omnistar/raw_data?destination=omnistar1j0rte6mvft3ugjyg3p2uvsrgzx9jr4dqn2len6

// blockTxs - http://testnetnode.omnistar.io:1317/cosmos/tx/v1beta1/txs/block/325607
// block - http://testnetnode.omnistar.io:1317/cosmos/base/tendermint/v1beta1/blocks/325607
